import styled from "styled-components";

export const HtmlEditorContainer = styled.div`
  margin-bottom: 32px;
  height: 100%;
  padding: 0px 32px;
  display: flex;
`;
